import {ReelsInitState} from '@gongxigames/framework/slot';
import {GameReelsView} from 'src/gameReels/GameReelsView';
import {GameReelsModule} from 'src/gameReels/GameReelsModule';
import {GameReelConstants} from 'src/gameReels/GameReelConstants';
import {WolfHaven} from 'com/gongxigames/math/wolfhaven/engine/WolfHaven';

export class GameReelsInitState extends ReelsInitState {
    public onEnterState(): void {
        this.view.dimensions = new Array(5).fill(GameReelConstants.DEFAULT_DIMENSION);
        this.view.setupReelStrip(WolfHaven.BG_SINGLE_REEL_SET.getReels(), GameReelConstants);
        super.onEnterState();
    }

    protected get view(): GameReelsView {
        return this.module.view as GameReelsView;
    }

    protected get module(): GameReelsModule {
        return this._module as GameReelsModule;
    }
}
